export interface Quote {
    author: string
    quote: string
}

const quotes: Quote[] = [
    {
        author: 'Ada Lovelace',
        quote:
            'Understand well as I may, my comprehension can only be an infinitesimal fraction of all I want to understand.',
    },
    {
        author: 'Ada Lovelace',
        quote:
            'The more I study, the more insatiable do I feel my genius for it to be.',
    },
    {
        author: 'Ada Lovelace',
        quote:
            'That brain of mine is something more than merely mortal; as time will show.',
    },
    {
        author: 'Ada Lovelace',
        quote:
            "If you can't give me poetry, can't you give me poetical science?",
    },
    {
        author: 'Grace Hopper',
        quote:
            "The most damaging phrase in the language is: 'It's always been done that way.'",
    },
    {
        author: 'Grace Hopper',
        quote:
            "I've always been more interested in the future than in the past.",
    },
    {
        author: 'Leo Szilard',
        quote:
            'No computer is ever going to ask a new, reasonable question. It takes trained people to do that.',
    },
    {
        author: 'Grace Hopper',
        quote:
            "You don't have to know what the future may bring. All you have to do is understand what the future may bring one day before most of the others do.",
    },
    {
        author: 'Judy Milhon',
        quote:
            'I’m trying to get root access to the future. I want to raid its system of thought. Grrr.',
    },
    {
        author: 'Ken Thompson',
        quote:
            "You can't trust code that you did not totally create yourself. (Especially code from companies that employ people like me.)",
    },
    {
        author: 'John Gilmore',
        quote:
            'The Internet treats censorship just like any other glitch: it routes around it.',
    },
    {
        author: 'St. Thomas Aquinas',
        quote:
            'Artificial wealth comprises the things which of themselves satisfy no natural need, for example money, which is a human contrivance.',
    },
]

export { quotes }
